/**************************************************
 * Nombre:       Equipo
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import {Parallax} from 'react-parallax';
import fondo from '../../../Recursos/equipo.png'
import Tarjeta_Indicadores from "../../Tarjetas/Tarjeta_Indicadores";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";


const Equipo = () => {
    const {sCell, masSM} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>


            <Parallax blur={1} bgImage={fondo} bgImageAlt="the cat" strength={150} style={{width: '100%'}}>
                <Grid
                    container
                    justifyContent={'center'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                >

                    <Grid
                        container
                        justifyContent={'center'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        sx={{maxWidth: '1400px', px: 3}}
                    >


                        <Grid container size={{xs: 12, sm: 12, md: 8}}
                              sx={{justifyContent: 'flex-start', mt: 10, mb: 42}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}
                                sx={{maxWidth: '1400px', px: 3}}
                                spacing={!masSM ? 6 : 8}
                            >

                                {items.map((it, index) => {
                                    return (
                                        <Grid container size={{xs: 6, sm: 3, md: 3}}
                                              sx={{justifyContent: 'flex-start'}}>
                                            <Tarjeta_Indicadores item={it}/>
                                        </Grid>
                                    )
                                })}

                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Parallax>


        </Grid>
    )

}
export default Equipo

const items = [
    {
        nombre: 'Clientes Felices',
        numero: 1500
    },
    {
        nombre: 'Tours',
        numero: 35
    },
    {
        nombre: 'Años de Experiencia',
        numero: 50
    },
    {
        nombre: 'Reconocimientos',
        numero: 10
    },
]